import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const shadowStyles = {
  elevation: 5,
  shadowColor: 'rgba(0, 0, 0, 0.16)',
  shadowOffset: {
    width: 0,
    height: 2
  },
  shadowRadius: 4,
  shadowOpacity: 1
}

const styles = StyleSheet.create({
  pb: x => {
    return {
      paddingBottom: x * 4
    }
  },
  status: {
    paddingTop: 4
  },
  placeholderIcon: {
    paddingBottom: 16
  },
  card: theme => ({
    paddingVertical: 12,
    paddingHorizontal: 16,
    flex: 1,
    borderRadius: 5,
    backgroundColor: theme.colors.cardBackgroundColor,
    ...shadowStyles
  }),
  header: {
    display: 'flex',
    marginBottom: 14,
    paddingBottom: 14,
    borderBottomWidth: 1,
    alignItems: 'center',
    flexDirection: 'row',
    borderBottomColor: Colors.activeGrey
  },
  headerText: {
    flexGrow: 1,
    marginLeft: 20
  },
  headerContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  subtitle: {
    fontSize: 14
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: 24
  },
  member: {
    marginBottom: 4,
    display: 'flex',
    paddingVertical: 12,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  text: {
    fontSize: 18
  },
  memberStatus: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  leaveGroup: {
    color: Colors.vfRed
  },
  memberIcon: {
    marginLeft: 8
  },
  orange: {
    color: '#FECB00'
  },
  helperText: {
    paddingTop: 16
  },
  red: {
    color: Colors.vfRed
  },
  kickContainer: {
    paddingTop: 64,
    paddingBottom: 36,
    paddingHorizontal: 16
  },
  kickMainContent: {
    display: 'flex',
    alignItems: 'center'
  },
  kickDescription: {
    fontSize: 16,
    marginTop: 24,
    maxWidth: 292,
    lineHeight: 18,
    textAlign: 'center'
  },
  kickTitle: {
    fontSize: 24,
    maxWidth: 314,
    marginTop: 24,
    lineHeight: 28,
    letterSpacing: 0.2,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  kickButton: {
    marginTop: 64
  },
  backButton: {
    marginTop: 16
  },
  noMembers: theme => ({
    padding: 24,
    borderWidth: 1,
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    borderStyle: 'dashed',
    borderColor: '#BEBEBE',
    justifyContent: 'center',
    backgroundColor: theme.colors.backgroundColorTwo
  }),
  noMemberText: theme => ({
    fontSize: 16,
    lineHeight: 18,
    color: theme.colors.textColorTwo,
    textAlign: 'center'
  }),
  success: {
    color: '#008A00'
  },
  error: {
    color: '#E60000'
  },
  pulsingBg: {
    width: 20,
    height: 20,
    borderRadius: 50,
    backgroundColor: '#FF424255'
  },
  relativeParent: {
    position: 'relative'
  },
  absoluteChild: {
    position: 'absolute'
  },
  memberCount: {
    fontWeight: 'bold'
  },
  lottie: {
    width: 20,
    height: 20
  },
  lottieHolder: {
    marginRight: 10,
    marginTop: 3
  }
})

export default styles
